var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarLoaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 20C29 18.22 28.4722 16.4799 27.4832 14.9999C26.4943 13.5198 25.0887 12.3663 23.4442 11.6851C21.7996 11.0039 19.99 10.8257 18.2442 11.1729C16.4984 11.5202 14.8947 12.3774 13.636 13.636C12.3774 14.8947 11.5202 16.4984 11.1729 18.2442C10.8257 19.99 11.0039 21.7996 11.6851 23.4442C12.3663 25.0887 13.5198 26.4943 14.9999 27.4832C16.4799 28.4722 18.22 29 20 29",
    stroke: "url(#paint0_angular_10967_28869)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_10967_28869",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 20) rotate(16.2602) scale(12.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#388AF7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#388AF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarLoaderIcon);
export default __webpack_public_path__ + "static/media/avatar_loader_icon.8eeab3bfb5c3c2b2246d42808ffad1c2.svg";
export { ForwardRef as ReactComponent };